export interface IPageMeta {
  title?: string,
  description?: string
}

// Keeps document.title and meta description in sync during SPA navigation.
// First page load is covered by public/ssr/getData.php — strings must mirror it.
export function setPageMeta(meta: IPageMeta): void {
  document.title = meta.title ? meta.title : "iconomy";

  if (meta.description) {
    let tag = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!tag) {
      tag = document.createElement("meta");
      tag.name = "description";
      document.head.appendChild(tag);
    }
    tag.content = meta.description;
  }
}
